
<div class="checkbox" @click.stop.prevent="toggle">
  <div class="wrapper">
    <input type="checkbox" :id="id" :checked="localValue" tabindex="-1" @click.prevent.stop />

    <icon class="icon active" v-show="localValue" name="check_box" />

    <icon class="icon" v-show="!localValue" name="check_box_outline_blank" />
  </div>

  <label v-if="label" @click.stop.prevent="toggle">
    {{ label }}
  </label>
</div>
